import {FieldErrors, FormState} from "react-hook-form";
import {useMemo} from "react";

const isOnlyServerError = (errors: FieldErrors<any>) => {
    return Object.entries(errors).every(([key, value]) => {
        return key === "root" && value && "serverError" in value;
    })
}

export const _useDisableSubmit = (formState: FormState<any>) => {
    return useMemo(() => {
        return formState.isSubmitting || (!formState.isValid && !isOnlyServerError(formState.errors));
    }, [formState]);
}
